module.exports = __webpack_public_path__ + "static/media/product4.286a73c2.png";